import { render, staticRenderFns } from "./InicioEduContinua.vue?vue&type=template&id=754b89cc&scoped=true"
import script from "./InicioEduContinua.vue?vue&type=script&lang=ts"
export * from "./InicioEduContinua.vue?vue&type=script&lang=ts"
import style0 from "./InicioEduContinua.vue?vue&type=style&index=0&id=754b89cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b89cc",
  null
  
)

export default component.exports